
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade/new",
      function () {
        return require("private-next-pages/trade/new/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade/new"])
      });
    }
  